module.exports = __webpack_public_path__ + "img/logo_image.256fe811.png";